import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useDragLayer } from 'react-dnd';

import { funnelResultQuery2 } from '../../queries';
import { useSelectedSite, useStableValue } from '/src/hooks';
import { getConvertedDateRange } from '/src/utils/date';
import { useFunnelEditorContext } from '../../funnel-editor-context';
import { DateRangeRow } from './DateRangeRow';
import { getTimeUnit } from '../../utils';
//import { getFakeFunnelData } from '../../fake-data';
import { MainChart } from './MainChart';

export function FunnelCharts({ stepsData }) {
  const { date } = useFunnelEditorContext();
  const { selectedSite } = useSelectedSite();
  const { isDragging } = useDragLayer((monitor) => ({
    isDragging: monitor.isDragging(),
  }));
  const stableStepsData = useStableValue(stepsData, isDragging);

  const convertedDateRange = getConvertedDateRange(date, true);
  const timeUnit = getTimeUnit(convertedDateRange);
  const { data, isFetching } = useQuery({
    ...funnelResultQuery2({
      siteId: selectedSite.id,
      startAt: convertedDateRange.startDate,
      endAt: convertedDateRange.endDate,
      timeUnit,
      steps: stableStepsData.map(({ id, type }) => ({ id, type })),
    }),
    enabled: !isDragging,
  });
  /*const data = useMemo(
    () =>
      getFakeFunnelData({
        steps: stableStepsData.map(({ id, type }) => ({ id, type })),
        dateRange: { startDate: convertedDateRange.startDate, endDate: convertedDateRange.endDate },
        timeUnit,
      }),
    [stableStepsData, timeUnit, convertedDateRange.startDate, convertedDateRange.endDate],
  );
  const isFetching = false;*/

  const summary = useMemo(() => data?.funnelResultNew?.summary ?? [], [data]);

  return (
    <section className="grow pl-5 pr-10 py-10">
      <DateRangeRow />
      <MainChart loading={isFetching} summary={summary} stepsData={stableStepsData} />
    </section>
  );
}
